import { configureStore } from '@reduxjs/toolkit';
import appReducer from './app.slice';
import userReducer from './user.slice';
import hirerReducer from './hirer.slice';
import talentReducer from './talent.slice';

const store = configureStore({
  reducer: {
    app: appReducer,
    user: userReducer,
    hirer: hirerReducer,
    talent: talentReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
